<template>
  <nayo-admin layout="layout_1"></nayo-admin>
</template>

<script>
  export default {}
</script>

<style lang="less">
  @import "assets/test/style";
</style>
